import request from '@/utils/request'
const PAY_API = process.env.VUE_APP_PAY_API
const PURCHASE_API = process.env.VUE_APP_PURCHASE_API

/**
 * 申请开立子账户
 */
export function openGuaranteePreSaveApi() {
  return request({
    url: PAY_API + '/v1/lbhAccount/openSubAccountNo',
    method: 'get'
  })
}

/**
 * 查询当前用户是否开户
 */
export function getGuaranteePreSaveApi() {
  return request({
    url: PAY_API + '/v1/lbhAccount/info',
    method: 'get'
  })
}

/**
 * 分页查询入账退款记录
 */
export function getGuaranteePreSaveTransactionPageApi(params) {
  return request({
    url: PAY_API + '/v1/lbhAccount/transaction/page',
    method: 'get',
    params
  })
}

/**
 * 分页查询额度占用明细
 */
export function getGuaranteePreSaveConsumePageApi(params) {
  return request({
    url: PAY_API + '/v1/lbhAccount/consume/page',
    method: 'get',
    params
  })
}

/**
 * 退款明细详情
 */
export function getGuaranteePreSaveRefundDetailApi(id) {
  return request({
    url: PAY_API + `/v1/lbhAccount/refund/detail/${id}`,
    method: 'get'
  })
}

/**
 * 申请退款
 */
export function applyGuaranteePreSaveRefundApi(data) {
  return request({
    url: PAY_API + '/v1/lbhAccount/applyRefund',
    method: 'post',
    data
  })
}

/**
 * 批量退款
 */
export function batchApplyGuaranteePreSaveRefundApi() {
  return request({
    url: PAY_API + '/v1/lbhAccount/batchRefund',
    method: 'get'
  })
}

/**
 * 保证金预存额度缴纳
 */
export function useGuaranteePreSaveInOrderApi(orderId, tradeId, data) {
  return request({
    url:
      PURCHASE_API +
      `/workbench/supplier/inquiry-orders/${orderId}/trades/${tradeId}/deposit-lhb`,
    method: 'post',
    data
  })
}
